import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { userCheckTkn } from '../api/user.api';
import Loading from './Loading';

function ProtectedRoute(props) {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      setIsLoading(true);

      const tkn = localStorage.getItem('tkn');
      const oauthUser = localStorage.getItem('user');

      if (tkn) {
        // Check token validity from backend
        const { response, err } = await userCheckTkn();

        if (err) {
          localStorage.removeItem('tkn');
          localStorage.removeItem('username');
          navigate('/signin');
        } else if (response) {
          localStorage.setItem('username', response.username);
          setIsLoading(false);
        }
      } else if (oauthUser) {
        // Google OAuth user present in localStorage, skip token check
        setIsLoading(false);
      } else {
        // No token or OAuth user, redirect
        navigate('/signin');
      }
    };

    checkAuth();
  }, [navigate]);

  return isLoading ? (
    <Loading />
  ) : (
    <Box sx={{ height: '100vh' }}>
      {props.children}
    </Box>
  );
}

export default ProtectedRoute;
